var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleQuote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1093 1.06953L7.41989 0C2.64996 3.23513 0 7.16588 0 10.401C0 13.5292 2.27939 15 4.21365 15C6.65161 15 8.37387 12.914 8.37387 10.7219C8.37387 8.87713 7.20789 7.29936 5.6442 6.71068C5.19392 6.54983 4.76993 6.41635 4.76993 5.64115C4.76993 4.65205 5.48563 3.18208 8.1093 1.06953ZM18.6294 1.06953L17.94 0C13.2227 3.23513 10.5201 7.16588 10.5201 10.401C10.5201 13.5292 12.8521 15 14.7864 15C17.2506 15 19 12.914 19 10.7219C19 8.87713 17.8077 7.29936 16.1906 6.71068C15.7403 6.54983 15.3426 6.41635 15.3426 5.64115C15.3426 4.65205 16.0846 3.18122 18.6286 1.06868L18.6294 1.06953Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuote);
export default __webpack_public_path__ + "static/media/doubleQuote.1ea16da660c433db5c6aeeee3e17ac35.svg";
export { ForwardRef as ReactComponent };